export const baseUrl = 'https://api.geniomd.com/v1/';
export const baseDashboardUrl = process.env.REACT_APP_BASE_DASHBOARD_URL;
export const basePdfUrl = `${window.location.protocol}//${window.location.hostname}/v2/pdf/`;

export const api = {
  auth: {
    login: 'auth/login',
    register: 'auth/register',
    config: 'vars',
    updateUser: 'users/update',
    forgotPassword: 'auth/forgot-password',
    resetPassword: 'auth/reset-password',
  },
  news: {
    list: 'news/tabs',
    search: 'news/search',
    newsDetails: 'news',
    drugDetails: 'drugs',
    diseasesDetails: 'diseases',
    drugsSearch: 'drugs/search',
    diseasesSearch: 'diseases/search',
    publishersSearch: 'publishers/search',
    sharedNews: 'shared',
    shareNews: 'share',
  },
  content: {
    changePassword: 'auth/change-password',
    recommendations: 'news',
    recommendationsDetails: 'recommendations',
    recommendationsByTab: 'recommendations/tab',
    home: 'home',
    specialities: 'specialities',
    filters: 'filters',
  },
  qna: {
    questions: 'qna/',
    ask: 'qna/ask',
    askStream: 'qna/askQuestionStream',
    userThreads: 'threads/my-threads',
    threads: 'threads',
  },
  summaries: {
    getById: 'summaries/',
    getByTab: 'summaries/tab',
    getByDateRange: 'summaries/date-range',
    generateVoice: 'summaries/generate-voice-summary',
  },
  predictions: {
    getById: 'predictions/',
    getByTab: 'predictions/tab',
    getByDateRange: 'predictions/date-range',
  },
  analysis: {
    getById: 'analysis/',
    getByTab: 'analysis/tab',
    getByDateRange: 'analysis/date-range',
  },
  translate: {
    googleTranslate: 'api/google-translate',
  },
};
